import Navbar from "../components/LandingPage/Navbar";
import Footer from "../components/LandingPage/Footer";
import PolicyContentRenderer from "../components/LandingPage/PolicyContentRenderer";
import TadarabLogo from "../components/icons/TadarabLogo";
import { cookiesTermsAndConditions } from "../constants/termsData";
import { useEffect } from "react";

export default function CookiesPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="policy-page">
      <Navbar />

      {/* Hero */}
      <div
        className="policy-page__hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/terms-conditions-hero-image.png)`,
        }}
      >
        <div className="policy-page__hero-inner">
          <span className="policy-page__hero-logo">
            <TadarabLogo />
          </span>
          <p className="policy-page__hero-title">سياسة ملفات تعريف الارتباط</p>
        </div>
      </div>

      {/* Body */}
      <div className="policy-page__body">
        <p className="policy-page__date">آخر تحديث: ١ يناير ٢٠٢٥</p>
        <PolicyContentRenderer content={cookiesTermsAndConditions} />
      </div>

      <Footer />
    </div>
  );
}
